// extracted by mini-css-extract-plugin
export default {"langItem":"LanguageToggler_langItem__SGo10"};